document.addEventListener("DOMContentLoaded", () => {
  const isProductPage = window.location.pathname.startsWith("/products/");

  if (isProductPage) {
    class CustomStickyElement {
      constructor() {
        this.isTidioOpen = false;

        this.waitForElements(() => {
          this.targetElement = document.querySelector("#tidio-chat");
          this.scopeFrom = document.querySelector(".product-form-wrapper");
          this.scopeTo = document.querySelector(".footer-group");
          this.stickyForm = document.querySelector(".product-sticky-form");

          if (!this.targetElement || !this.scopeFrom || !this.scopeTo) return;

          this.applyInitialPosition();
          this.checkInitialScrollPosition();

          this.intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this));
          this.intersectionObserver.observe(this.scopeFrom);
          this.intersectionObserver.observe(this.scopeTo);

          if (window.innerWidth <= 767) {
            this.lastScrollY = window.scrollY;
            this.isScopeFromPassed = false;
            this.isAtFooter = false;
            this.lastDirection = "up";
            window.addEventListener("scroll", this.handleMobileScroll.bind(this), { passive: true });
          } else {
            window.addEventListener("scroll", this.handleDesktopScroll.bind(this), { passive: true });
          }

          this.startTidioOpenPolling();
        });
      }

      waitForElements(callback) {
        const interval = setInterval(() => {
          const tidioChat = document.querySelector("#tidio-chat");
          const scopeFrom = document.querySelector(".product-form-wrapper");
          const scopeTo = document.querySelector(".footer-group");

          if (tidioChat && scopeFrom && scopeTo) {
            clearInterval(interval);
            callback();
          }
        }, 200);
      }

      applyInitialPosition() {
        this.targetElement.style.transition = "transform 0.3s ease-out";
        this.targetElement.style.transform = "translateY(0)";
      }

      checkInitialScrollPosition() {
        const isPastScopeFrom = this.scopeFrom.getBoundingClientRect().bottom < 0;
        if (isPastScopeFrom) {
          this.isScopeFromPassed = true;
          this.setTidioTransform(-70);
        }
      }

      handleIntersection(entries) {
        if (!this.targetElement) return;

        entries.forEach((entry) => {
          if (entry.target === this.scopeFrom) {
            this.isScopeFromPassed = entry.boundingClientRect.bottom < 0;

            if (!this.isScopeFromPassed) {
              this.setTidioTransform(0);
            } else if (this.isScopeFromPassed && window.innerWidth > 767) {
              // Only move up if sticky form present on desktop
              if (this.stickyForm) {
                this.setTidioTransform(-100);
              } else {
                this.setTidioTransform(0);
              }
            }
          }

          if (entry.target === this.scopeTo) {
            const wasAtFooter = this.isAtFooter;
            this.isAtFooter = entry.isIntersecting;

            if (this.isAtFooter) {
              this.forceMoveOnFooter();
            } else if (wasAtFooter && !this.isAtFooter && window.innerWidth > 767) {
              if (this.stickyForm) {
                this.setTidioTransform(-100);
              } else {
                this.setTidioTransform(0);
              }
            }
          }
        });
      }

      handleMobileScroll() {
        if (!this.targetElement || window.innerWidth > 767) return;
        if (this.isTidioOpen) return;

        const currentScrollY = window.scrollY;
        const currentTransformY = this.getTidioTransform();
        const hasStickyForm = !!document.querySelector(".product-sticky-form");
        const scopeFromBottom = this.scopeFrom.getBoundingClientRect().bottom;

        if (scopeFromBottom >= 0) {
          if (currentScrollY > this.lastScrollY) {
            if (currentTransformY !== -70) {
              this.setTidioTransform(-70);
            }
          } else if (currentScrollY < this.lastScrollY) {
            if (currentTransformY !== 0) {
              this.setTidioTransform(0);
            }
          }

          this.lastScrollY = currentScrollY;
          return;
        }

        if (currentScrollY > this.lastScrollY) {
          this.lastDirection = "down";

          if (!this.isScopeFromPassed && currentTransformY !== -70) {
            this.setTidioTransform(-70);
          } else if (this.isScopeFromPassed && hasStickyForm && currentTransformY !== -130) {
            this.setTidioTransform(-130);
          } else if (this.isScopeFromPassed && !hasStickyForm && currentTransformY !== -70) {
            this.setTidioTransform(-70);
          }
        } else if (currentScrollY < this.lastScrollY) {
          this.lastDirection = "up";

          if (hasStickyForm) {
            if (currentTransformY !== -70) {
              this.setTidioTransform(-70);
            }
          } else {
            if (currentTransformY !== 0) {
              this.setTidioTransform(0);
            }
          }
        }

        if (this.isAtFooter) {
          this.forceMoveOnFooter();
        }

        this.lastScrollY = currentScrollY;
      }

      handleDesktopScroll() {
        if (!this.targetElement || window.innerWidth <= 767) return;

        if (!this.isAtFooter && this.isScopeFromPassed) {
          // Only move if sticky form exists
          if (this.stickyForm) {
            this.setTidioTransform(-100);
          } else {
            this.setTidioTransform(0);
          }
        }
      }

      forceMoveOnFooter() {
        if (!this.targetElement) return;
        let newTransform = this.lastDirection === "down" ? -70 : 0;
        if (this.getTidioTransform() !== newTransform) {
          this.setTidioTransform(newTransform);
        }
      }

      getTidioTransform() {
        const computedTransform = getComputedStyle(this.targetElement).transform;
        if (computedTransform !== "none") {
          const matrixValues = computedTransform.match(/matrix.*\((.+)\)/);
          if (matrixValues) {
            return parseFloat(matrixValues[1].split(", ")[5]);
          }
        }
        return 0;
      }

      setTidioTransform(value) {
        this.targetElement.style.transform = `translateY(${value}px)`;
      }

      startTidioOpenPolling() {
        let lastHash = window.location.hash;

        setInterval(() => {
          const currentHash = window.location.hash;
          if (currentHash !== lastHash) {
            lastHash = currentHash;

            if (currentHash === "#mobile-widget") {
              this.isTidioOpen = true;

              setTimeout(() => {
                if (!this.targetElement) return;
                this.targetElement.style.setProperty("transform", "translateY(0px)", "important");
              }, 5);
            } else {
              this.isTidioOpen = false;
            }
          }
        }, 300);
      }
    }

    setTimeout(() => {
      new CustomStickyElement();
    }, 1000);
  }
});
